var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54688 25H11.4531C11.9925 25 12.4297 24.5628 12.4297 24.0234C12.4297 23.4841 11.9925 23.0469 11.4531 23.0469H7.54688C7.00752 23.0469 6.57031 23.4841 6.57031 24.0234C6.57031 24.5628 7.00752 25 7.54688 25Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C8.96064 0 8.52344 0.437207 8.52344 0.976562V2.02319C5.21509 2.49849 2.66406 5.35127 2.66406 8.78906V14.7928C2.66406 15.1369 2.50903 15.45 2.27837 15.5719C1.31152 16.0824 0.710938 17.0756 0.710938 18.1641C0.710938 19.7795 2.0252 21.0938 3.64062 21.0938H15.3594C16.9748 21.0938 18.2891 19.7795 18.2891 18.1641C18.2891 17.0756 17.6885 16.0824 16.7216 15.5719C16.4909 15.45 16.3359 15.137 16.3359 14.7928V8.78906C16.3359 5.35127 13.7849 2.49849 10.4766 2.02319V0.976562C10.4766 0.437207 10.0394 0 9.5 0ZM14.3828 8.78906V14.7928C14.3828 15.8739 14.9295 16.8342 15.8097 17.299C16.1343 17.4704 16.3359 17.8019 16.3359 18.1641C16.3359 18.7025 15.8979 19.1406 15.3594 19.1406H3.64062C3.10215 19.1406 2.66406 18.7025 2.66406 18.1641C2.66406 17.8019 2.86572 17.4704 3.19033 17.299C4.07046 16.8342 4.61719 15.8739 4.61719 14.7928V8.78906C4.61719 6.09668 6.80762 3.90625 9.5 3.90625C12.1924 3.90625 14.3828 6.09668 14.3828 8.78906Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a5c768287a2ab394f9f1279c8f21ab31.svg";
export { ForwardRef as ReactComponent };